var Header                      = require("./Header"),
    NoContentView               = require("./NoContentView"),
    PrefixedScrollRepeater      = require("app/ui/repeaters/PrefixedScrollRepeater"),
    RepeaterPaddedListArranger  = require("enyo-ui/RepeaterPaddedListArranger"),
    ScrollAnchorMemorySupport   = require("app/ui/ScrollAnchorMemorySupport"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    frameThrottle               = require("enyo-perf/utils").frameThrottle,
    get                         = require("object-path").get,
    kind                        = require("enyo/kind"),
    quickMacroize               = require("enyo/macroize").quickMacroize,
    resolveCategoryRowKind      = require("app/utils/resolveCategoryRowKind"),
    themeVars                   = require("app/theme/variables");

require("./PageView.less");
require("app/theme/ScrollerDecoratorScrollbars--page.less");

module.exports = kind(/** @lends  app.BrandPage.PageView.prototype */ {

    /**
     * @private
     */
    name: "app.BrandPage.PageView",

    /**
     * @private
     */
    kind: ScrollerDecoratorScrollbars,

    /**
     * @private
     */
    classes: "app-brand-page-page-view",

    /**
     * @private
     */
    fit: true,

    /**
     * @public
     */
    scrollerPath: ".$.categories.$.scroller",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * Default scroll-bars theme for desktop, minimal for mobile.
     *
     * @public
     */
    theme: "page",

    /**
     * If true, chrome will show when scrolling, hide when not scrolling.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnScroll: true,

    /**
     * @private
     */
    components: [{
        name:       "categories",
        kind:       PrefixedScrollRepeater,
        mixins:     [ScrollAnchorMemorySupport],
        classes:    "app-brand-page-page-view__categories",
        components: [{
            name:    "header",
            kind:    Header,
            classes: "app-brand-page-page-view__header"
        }, {
            name:    "noContent",
            kind:    NoContentView,
            classes: "app-brand-page-page-view__no-content"
        }],
        drawAsync:       true,
        scrollerOptions: {
            fit: true
        },
        arrangerKind:    RepeaterPaddedListArranger,
        arrangerOptions: {
            direction:        "vertical",
            defaultChildSize: 200,

            /**
             * The amount of padding before the first child.
             *
             * @return {number}  The padding
             * @public
             */
            padBefore: function() {
                return themeVars.getContentPaddingVerticalPx();
            },

            /**
             * The amount of padding after the last child.
             *
             * @return {number}  The padding
             * @public
             */
            padAfter: function() {
                return themeVars.getContentPaddingVerticalPx() * 2;
            }
        },

        /**
         * Return the right kind of row depending on the type of category.
         *
         * @param   {?string}       category  The category
         * @return  {enyo.Control}  The row kind
         * @public
         */
        getChildKind: resolveCategoryRowKind
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state       = this.state || {},
            numChildren = get(state, "data.children.length", 0),
            numRows     = get(state, "data.dashboard.length", 0),
            $categories = this.$.categories,
            anchorKey   = quickMacroize("BrandPage/PageView/{$slug}", {
                slug: get(state, "data.meta.slug", null)
            });

        this.$.header.set("data", get(state, "data", null));

        $categories.addRemoveClass("no-content", numChildren + numRows === 0);
        $categories.$.client.set("fit", numChildren + numRows === 0);

        switch (get(state, "data.embedded_dashboard_position", "bottom")) {
            case "top":
                $categories.set("data", get(state, "data.dashboard", []).concat(get(state, "data.children", [])));
                break;
            case "bottom":
            default:
                $categories.set("data", get(state, "data.children", []).concat(get(state, "data.dashboard", [])));
                break;
        }
        $categories.set("anchorKey", anchorKey);

        anchorKey && $categories.restoreAnchor();
    }

});
